import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ContactSalesDialog' })({
    content: {
        padding: 32,
        maxWidth: 342
    },
    message: {
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 8
    },
    title: {
        margin: 0,
        color: '#232323',
        fontSize: 18,
        fontWeight: 700,
        lineHeight: '27px',
        letterSpacing: '-0.6px'
    },
    description: {
        paddingTop: 8,
        margin: 0,
        color: '#8E8E8E',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.32px'
    },
    icon: {
        fontSize: 32
    },
    close: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: '#282D31'
    }
});
